import * as React from "react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { routesFormRedux } from "../redux/RoutesFormRedux";
import { RoutesFormModel } from "../types/RoutesFormModel";
import { routeAgreementUpdateShouldTriggerRecalculation } from "../lib/RouteAgreementRecalculationDecider";
import { clearAllPriceStatisticsForRouteAgreement } from "../redux/thunks/ClearAllPriceStatisticsForRouteAgreement";
import { SwitchForRouteAgreementSalesReady } from "@/components/data-driven-inputs/switches/SwitchForRouteAgreementSalesReady";
import { RouteAgreement } from "../../product-and-price/customers/customer-details/types";
import { Indent, Row, Text } from "@stenajs-webui/core";
import { cssColor } from "@stenajs-webui/theme";

interface Props {
  routeAgreementId: string;
  routeAgreement: Pick<RouteAgreement, "statusCode">;
}

export const SalesReadySwitch: React.FC<Props> = ({
  routeAgreementId,
  routeAgreement,
}) => {
  const dispatch = useDispatch();
  const routesFormModel = useSelector(routesFormRedux.selectors.getEntity);

  const setFields = useCallback(
    (fields: Partial<RoutesFormModel>) => {
      dispatch(routesFormRedux.actions.setEntityFields(fields));

      if (routeAgreementUpdateShouldTriggerRecalculation(fields)) {
        dispatch(clearAllPriceStatisticsForRouteAgreement(routeAgreementId));
      }
    },
    [dispatch, routeAgreementId]
  );

  return (
    <Row alignItems={"center"}>
      <SwitchForRouteAgreementSalesReady
        routeAgreement={routeAgreement}
        value={routesFormModel.isSalesReady}
        onValueChange={(isSalesReady) => setFields({ isSalesReady })}
      />
      <Indent num={0.5} />
      <Text color={cssColor("--lhds-color-ui-500")}>Sales ready</Text>
    </Row>
  );
};
